export default {
      id: "upload-usage",
      viewBox: "0 0 31 23",
      url: __webpack_public_path__ + "icons.svg#upload",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/upload.svg
// module id = 289
// module chunks = 0